module.exports = __webpack_public_path__ + "img/placeholder2.dc1d10f8.jpg";